module.exports = __webpack_public_path__ + "img/arrow_left_3.c326b19e.svg";